module.exports = __webpack_public_path__ + "22300052dd4658104f64b43cbbc49046.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map/map-bg.png
// module id = 2654
// module chunks = 0